/**
 * Module-level handoff registration for AI jobs. The
 * `<AiJobNotificationProvider>` registers itself once on mount; callers fire
 * `handoffAiJobToBackground(jobId)` to add a job to the provider's tracked
 * set so the global toast fires on completion even if the user navigates
 * away. Lives in its own file so fast-refresh keeps working — the React
 * file in the same directory only exports components.
 */

let handler: ((jobId: string) => void) | null = null;

export function setAiJobHandoffHandler(next: ((jobId: string) => void) | null): void {
  handler = next;
}

export function handoffAiJobToBackground(jobId: string): void {
  handler?.(jobId);
}
